// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Helmet } from 'react-helmet';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
// import Filter from '../../../elements/Filter/Filter';
// import FilterDrawer from '../../../elements/Filter/Drawer/FilterDrawer';
import update from 'immutability-helper';
// import { generateTags } from '../../../elements/Filter/utils';
import Loading from '../../../elements/Loading/Loading';
import AlertContainer from '../../alert/container/AlertContainer';
import ResultBox from './ResultBox/ResultBox';
import environment from '../../../environment';
import ProductModal from './ProductModal/ProductModal';
import Modal from '../../../elements/Modal/Modal';
import HomeForm from '../../home/components/HomeForm/HomeForm';
import Banner from '../../../elements/Banner/Banner';
import { Link } from 'react-router-dom';
import { FormValidator } from '../../../utils/form';
import WishListModal from '../../my-wish-lists/components/WishListModal/WishListModal';
import { animateScroll as scroll, scroller } from 'react-scroll';
import queryString from 'query-string';
import ShareListModal from './ShareListModal/ShareListModal';

import style from './WishList.scss';
import icons from '../../../assets/styles/icons.scss';
import buttonStyle from '../../../assets/styles/button.scss';
// import filterOptionsStyle from '../../../assets/styles/filter-options.scss';
// import filterStyles from '../../../assets/styles/filter.scss';
import coverImg from '../../../assets/img/meta-cover-lightblue.png';

import type {ScrappedProduct, User, WishList as WishListType, WishListItem, WishListProduct } from '../../../entities';
import type { HTTPError } from '../../../error';
import type { LocaleState } from '../../locale/duck';
import type { FilterCheckbox } from '../../../elements/Filter/Filter';
import type { Location, Match } from '../../../router';
import type { LocalValuesState } from '../../local-values/duck';
import type { FormValidationResult } from '../../../utils/form';

type Props = {
  +match: Match;
  +location: Location;
  +user?: User;
  +authenticated?: boolean;
  +localeState: LocaleState;
  +localValues: LocalValuesState;
  +handleOpenAuthModal?: (openLoginView?: boolean) => void;
  +authModalVisible?: boolean;
  +getUserWishList: (userId: string, nameSlug: string, queryFilter?: { [key: string]: string }) => void;
  +isFetchingWishList?: boolean;
  +currentWishList?: WishListType;
  +postProduct: (product: WishListProduct, userId: string, nameSlug: string) => void;
  +isPostingProduct?: boolean;
  +editProduct: (product: WishListProduct, productId: string, userId: string, nameSlug: string) => void;
  +isEditingProduct?: boolean;
  +deleteProduct: (productId: string, userId: string, nameSlug: string) => void;
  +isDeletingProduct?: boolean;
  +editLike: (liked: boolean, userId: string, nameSlug: string) => void;
  +isEditingLike?: boolean;
  +error?: HTTPError;
  +goToRedirect: (route: string) => void;
  +resetWishListState: () => void;
  +putWishList: (req: any, userId: string, slug: string) => void;
  +putWishListSuccess: boolean;
  +putWishListError: HTTPError;
  +isPuttingWishList: boolean;
  +deleteWishList: (userId: string, slug: string) => void;
  +isDeletingWishList: boolean;
  +deleteWishListError: HTTPError;
  +deleteWishListSuccess: boolean;
  +scrapUrl: (url: string) => void;
  +isScrappingUrl?: boolean;
  +scrappedProduct?: ScrappedProduct;
  +scrapSuccess?: boolean;
  +scrapUrlError?: HTTPError;
};

type State = {
  drawerOpen: boolean;
  filter: {
    minPrice: {
      value: string;
    };
    maxPrice: {
      value: string;
    };
    openPrice: boolean;
  };
  sort: {
    value: string;
    name: string;
  };
  order: {
    value: 'ASC' | 'DESC';
  };
  productModalOpen?: boolean;
  deleteModalOpen?: boolean;
  productId?: string;
  shareListModalOpen?: boolean;
  editWishListModal: boolean;
  deleteWishListModal: boolean;
  name: {
    value: string;
    errors?: string[];
  };
  image: {
    value: string;
    valueURI?: string;
    pristine: boolean;
    errors?: string[];
  };
  wishListTypeOption: {
    value: number;
    errors?: string[];
  };
  enableWishListTypes: boolean;
};

const messages = defineMessages({
  sortHighestTotalValue: {
    id: 'sort.option.highestTotalValue',
  },
  sortLowestTotalValue: {
    id: 'sort.option.lowestTotalValue',
  },
  title: {
    id: 'wishList.document.title',
  },
  description: {
    id: 'wishList.document.description',
  },
});

const initialState = {
  drawerOpen: false,
  filter: {
    minPrice: {
      value: '0',
    },
    maxPrice: {
      value: '5000',
    },
    openPrice: true,
  },
  sort: {
    value: '',
    name: '',
  },
  order: {
    value: 'DESC',
  },
  productModalOpen: false,
  deleteModalOpen: false,
  productId: '',
  shareListModalOpen: false,
  editWishListModal: false,
  deleteWishListModal: false,
  name: {
    value: '',
  },
  image: {
    value: '',
    valueURI: '',
    pristine: true,
  },
  wishListTypeOption: {
    value: 0,
  },
  enableWishListTypes: false,
};

const optionTypes = ['PRIVATE', 'UNLISTED', 'PUBLIC'];
const optionsTypesIntl = [
  'wishList.subtitle.private',
  'wishList.subtitle.shared',
  'wishList.subtitle.public',
];

const SCROLL_OPTIONS = {
  duration: 350,
  delay: 0,
  smooth: 'easeInOutQuart',
  offset: -100,
};

export default class WishList extends Component<Props, State> {
  formValidator: FormValidator;
  state = initialState;
  wishListSlug = '';
  ownerUserId = '';
  pendingAction: ?'like';

  constructor(props: Props) {
    super(props);

    this.formValidator = new FormValidator({
      name: {
        required: 'required',
      },
      image: {
        required: 'required',
      },
    })
  }

  componentDidMount() {
    const { getUserWishList, currentWishList, match, location } = this.props;
    const parsedQuery = queryString.parse(location.search);
    if (!!parsedQuery && parsedQuery.enableWishListTypes === 'true') {
      this.setState({
        enableWishListTypes: true,
      });
    }

    if (!!match.params && !!match.params['nameSlug']) {
      this.wishListSlug = match.params['nameSlug'];
      this.ownerUserId = match.params['userId'];
    }
    if (!currentWishList) {
      getUserWishList(this.ownerUserId, this.wishListSlug);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const {
      user, getUserWishList, isPostingProduct, isEditingProduct, isDeletingProduct, error, goToRedirect,
      isPuttingWishList, isDeletingWishList, currentWishList, putWishListSuccess, deleteWishListSuccess,
      resetWishListState, authModalVisible, authenticated, editLike,
    } = this.props;
    if ((user && !prevProps.user && !!user) || (putWishListSuccess !== prevProps.putWishListSuccess)) {
      if (user && user.id === this.ownerUserId) {
        getUserWishList(user.id, this.wishListSlug);
      }
    }
    if (prevProps.isPostingProduct && !isPostingProduct && !error) {
      this.handleCloseProductModal();
    }
    if (prevProps.isEditingProduct && !isEditingProduct && !error) {
      this.handleCloseProductModal();
    }
    if (prevProps.isDeletingProduct && !isDeletingProduct && !error) {
      this.handleCloseDeleteModal();
    }

    if ((!prevProps.isPuttingWishList && isPuttingWishList)) {
      scroll.scrollTo(0, {
        duration: 400,
      });
    }

    if (!!currentWishList && prevProps.currentWishList !== currentWishList) {
      let typeIndex = optionTypes.indexOf(currentWishList.subtype);
      typeIndex = typeIndex > -1 ? typeIndex : 0;
      this.setState({
        name: {
          value: currentWishList.name,
        },
        image: {
          value: currentWishList.image,
          pristine: true,
        },
        wishListTypeOption: {
          value: typeIndex,
        },
      });
    }

    if (prevProps.authModalVisible && !authModalVisible) {
      this.pendingAction = undefined;
    }

    if (!prevProps.authenticated && authenticated) {
      if (this.pendingAction === 'like') {
        if (!!currentWishList) {
          editLike(!currentWishList.liked, this.ownerUserId, this.wishListSlug);
        }
      }
    }

    if (deleteWishListSuccess && deleteWishListSuccess !== prevProps.deleteWishListSuccess) {
      goToRedirect('/my-wish-lists');
    }
  }

  componentWillUnmount() {
    const { resetWishListState } = this.props;
    resetWishListState();
  }

  handleFetchWishList = () => {
    const { getUserWishList } = this.props;
    getUserWishList(this.ownerUserId, this.wishListSlug, this.buildQueryParams());
  };

  handleChangeSort = (e: Event) => {
    if (e.target instanceof HTMLSelectElement) {
      const option = e.target.options[e.target.selectedIndex];
      const dataset: { sort: string, order: 'ASC' | 'DESC' } = (option.dataset: any);
      // this.fireEvent();
      this.setState({
        sort: {
          value: option.value,
          name: dataset.sort,
        },
        order: {
          value: dataset.order,
        },
      }, () => this.handleFetchWishList());
    }
  };

  buildQueryParams(): { [key: string]: any } {
    const params = {};
    const { filter, sort, order } = this.state;
    if (filter.minPrice) params.minprice = filter.minPrice.value;
    if (filter.maxPrice) params.maxprice = filter.maxPrice.value;
    // Sort & Ord
    if (sort.name) {
      params.sort = sort.name;
    }
    if (order.value) {
      params.order = order.value;
    }
    return params;
  }

  handleOpen = (name: string) => {
    this.setState((state: State) => {
      return {
        filter: update(state.filter, {
          [name]: { $set: !state.filter[name] },
        }),
      };
    });
  };

  handleChangePrice = (values: number[], isDesktop: boolean = true) => {
    this.handleChangeFilterSingleValueCreator(isDesktop)('minPrice', { value: values[0] });
    this.handleChangeFilterSingleValueCreator(isDesktop)('maxPrice', { value: values[1] });
  };

  handleChangeFilterSingleValueCreator = (isDesktop: boolean) =>
    (name: string, value: any) => {
      this.setState((state: State) => {
        return {
          filter: update(state.filter, {
            [name]: { $set: value },
          }),
        };
      }, () => {
        if (isDesktop) this.handleFetchWishList();
      });
    };

  generateFilterFields = (stores: ?FilterCheckbox[], { filter }: State, isDesktop: boolean) => [
    {
      type: 'range',
      titleIntl: 'filter.price.title',
      isOpen: filter.openPrice,
      name: 'price',
      minStateValue: filter.minPrice,
      maxStateValue: filter.maxPrice,
      options: {
        min: 0,
        max: 5000,
        defaultValue: [0, 5000],
        onChange: (values: number[]) => this.handleChangePrice(values, isDesktop),
      },
      handleOpen: () => this.handleOpen('openPrice'),
    },
  ];

  handleOpenDrawer = () => {
    this.setState({ drawerOpen: true });
  };

  handleCloseDrawer = () => {
    this.setState({
      drawerOpen: false,
    });
    this.handleFetchWishList()
  };

  handleClearFilters = () => {
    this.setState(initialState,
      () => this.handleFetchWishList());
  };

  handleDeleteTag = (key?: string, name?: string) => {
    const updateQuery = {};
    switch (key) {
      case 'xxxx':
        if (name) {
          updateQuery[key] = {
            [name]: { $set: false },
          };
        }
        break;
    }
    this.setState((prevState: State) => update(prevState, {
      filter: updateQuery,
    }), () => this.handleFetchWishList());
  };

  handleOpenProductModal = (productId?: string) => {
    if (!!productId) {
      this.setState({ productModalOpen: true, productId });
    } else {
      this.setState({ productModalOpen: true });
    }
  };

  handleCloseProductModal = () => {
    this.setState({ productModalOpen: false, productId: '' });
  };

  handlePostProduct = (product: WishListProduct) => {
    const { postProduct } = this.props;
    postProduct(product, this.ownerUserId, this.wishListSlug);
  };

  handleEditProduct = (product: WishListProduct, productId: string) => {
    const { editProduct } = this.props;
    editProduct(product, productId, this.ownerUserId, this.wishListSlug);
  };

  handleDeleteProduct = () => {
    const { productId } = this.state;
    const { deleteProduct } = this.props;
    if (!productId) return;
    deleteProduct(productId, this.ownerUserId, this.wishListSlug);
  };

  handleOpenDeleteModal = (productId: string) => this.setState({ deleteModalOpen: true, productId });

  handleCloseDeleteModal = () => this.setState({ deleteModalOpen: false });

  handleShareListModalOpen = () => this.setState({ shareListModalOpen: true });

  handleShareListModalClose = () => this.setState({ shareListModalOpen: false });

  handleChangeInputText = (e: Event) => {
    if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
      const { value, name } = e.target;
      this.setState({ [name]: { value } });
    }
  };

  handleFocusInputText = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      this.setState({ [name]: { value } });
    }
  };

  handleChangeImage = (acceptedFiles: File[]) => {
    if (acceptedFiles.length) {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsDataURL = reader.result;
        this.setState({
          image: {
            valueURI: fileAsDataURL.toString(),
            value: '',
            pristine: false,
          },
        });

      };
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => {
        console.log('error');
        this.setState({
          image: {
            value: '',
            errors: ['maxSize'],
            pristine: false,
          },
        });
        console.log('file reading has failed');
      };
      reader.readAsDataURL(acceptedFiles[0]);
    }
  };

  handleDeleteImage = () => {
    // We do it outside on purpose because we want to register the section at the time executed.
    this.setState({
      image: {
        valueURI: '',
        value: '',
        pristine: false,
      },
    });
  };

  handleChangeTypeOption = (value: number) => {
    this.setState({
      wishListTypeOption: {
        value,
      },
    });
  };

  validateForm = (): boolean => {
    const { name, image } = this.state;
    let resp = true;
    let fieldToScroll = '';

    const errors = this.formValidator.validateForm({
      name: name.value,
      image: image.value || image.valueURI,
    });

    if (errors.length) {
      resp = false;
      errors.forEach((error: FormValidationResult) => {
          this.setState((state: State) => update(state, {
            [error.field]: {
              errors: { $set: error.errors },
            },
          }));
        },
      );
      fieldToScroll = errors[0].field;
    }
    if (fieldToScroll) {
      scroller.scrollTo(fieldToScroll, SCROLL_OPTIONS)
    }

    return resp;
  };

  handleClickPutWishList = () => {
    const { image, wishListTypeOption, name } = this.state;
    const { putWishList, currentWishList } = this.props;

    const req: { [string]: string } = {
      name: name.value,
      type: optionTypes[wishListTypeOption.value],
    };

    if (!image.pristine) {
      if (image.value) {
        req.image = image.value;
      }
      if (image.valueURI) {
        req.imageURI = image.valueURI;
      }
    }

    if (!!currentWishList)
      putWishList(req, currentWishList.user.id, currentWishList.slug);

  };

  handleClickDeleteWishList = () => {
    const { deleteWishList, currentWishList } = this.props;
    if (!!currentWishList)
      deleteWishList(currentWishList.user.id, currentWishList.slug);
    this.handleDeleteModalClose();
  };

  handleEditModalOpen = () => {
    const { currentWishList } = this.props;
    this.setState({ editWishListModal: true });
  };

  handleWishListModalClose = () => this.setState({ editWishListModal: false });

  handleDeleteModalOpen = () => this.setState({ deleteWishListModal: true });

  handleDeleteModalClose = () => this.setState({ deleteWishListModal: false });

  isLoading = () => {
    const { isFetchingWishList, isPuttingWishList, isDeletingWishList } = this.props;
    return isFetchingWishList || isPuttingWishList || isDeletingWishList;
  };

  handleClickLikeBtn = () => {
    const { currentWishList, user, editLike, handleOpenAuthModal } = this.props;
    if (!!user) {
      if (!!currentWishList) {
        editLike(!currentWishList.liked, this.ownerUserId, this.wishListSlug);
      }
    } else if (!!handleOpenAuthModal) {
      handleOpenAuthModal();
      this.pendingAction = 'like';
    }
  };

  render() {
    const {
      match, user, localeState, localValues, isFetchingWishList, currentWishList,
      isPostingProduct, isEditingProduct, isDeletingProduct, goToRedirect, location, isPuttingWishList,
      isDeletingWishList, scrapUrl, isScrappingUrl, scrappedProduct, scrapSuccess, scrapUrlError,
    } = this.props;
    const {
      sort, drawerOpen, productModalOpen, deleteModalOpen, productId, shareListModalOpen, editWishListModal,
      wishListTypeOption, name, image, deleteWishListModal, enableWishListTypes,
    } = this.state;
    const code = !!user ? user.referralCoupon : '';

    // const filterFields = this.generateFilterFields(xxxx, this.state, true);
    // const tags: any = generateTags((filterFields: any), this.handleDeleteTag, this.context.intl.formatMessage);
    const sortNativeSelect = (
      <select value={sort.value}
              onChange={this.handleChangeSort}>
        <option value="highestTotalValue" data-sort="TOTAL"
                data-order="DESC">{this.context.intl.formatMessage(messages.sortHighestTotalValue)}</option>
        <option value="lowestTotalValue" data-sort="TOTAL"
                data-order="ASC">{this.context.intl.formatMessage(messages.sortLowestTotalValue)}</option>
      </select>
    );
    /*const filterContent =
      <Filter filterFields={(this.generateFilterFields(xxxx, this.state, true): any)}
              handleDeleteTag={this.handleDeleteTag}
              hasBorder/>;*/
    const noResult = (!currentWishList || (!!currentWishList && !currentWishList.items)) && !isFetchingWishList;

    const productsResult = !!currentWishList && !!currentWishList.items &&
      currentWishList.items.map((product: WishListItem, n: number) => (
        <ResultBox key={n}
                   product={product}
                   isOwner={currentWishList.isOwner}
                   handleOpenProductModal={this.handleOpenProductModal}
                   handleOpenDeleteModal={this.handleOpenDeleteModal}/>
      ));

    const urlRedirect = `${environment.baseUrl[localeState.domainCountry || 'US']}${match.url}`;
    const description = this.context.intl.formatMessage((messages.description));
    const title = currentWishList ? `${currentWishList.name} | Qempo` : this.context.intl.formatMessage((messages.title));
    const metaImage = currentWishList && currentWishList.image ? `${currentWishList.image}` : coverImg;
    // const baseUrl = environment.baseUrl[localeState.domainCountry || 'US'];

    return (
      <Fragment>
        <Helmet meta={[
          { name: 'description', content: description },
          // { property: 'og:image', content: `${baseUrl}${coverImg}` },
          { property: 'og:image', content: metaImage },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          { name: 'twitter:title', content: title },
          // { name: 'twitter:twitter:image', content: `${baseUrl}${coverImg}` },
          { name: 'twitter:twitter:image', content: metaImage },
          { name: 'twitter:twitter:description', content: description }]}>
          <title>{title}</title>
        </Helmet>
        {user && user.id === this.ownerUserId &&
        <Banner titleElement={
          <FormattedMessage id="wishList.return">{
            txt => <h1>
              <Link to={'/my-wish-lists'}><i className={icons.iconChevronLeftMedium}/>{txt}</Link>
            </h1>
          }</FormattedMessage>}/>}
        <section className={style.wishListWrapper}>
          {!!currentWishList && !this.isLoading() &&
          <section className={style.topWrap}>
            <section className={style.header}>
              {!!currentWishList.image && <img src={currentWishList.image} alt="user-image"/>}
              <section className={style.titles}>
                <p>{currentWishList.name}</p>
                {!!currentWishList.user &&
                <div>
                  {currentWishList.isOwner ?
                    <FormattedMessage id={optionsTypesIntl[wishListTypeOption.value]}>{
                      text => <p className={style.subtitle}>{text}</p>
                    }</FormattedMessage> :
                    <p className={style.subtitle}>
                      {currentWishList.user.firstName}&nbsp;{currentWishList.user.lastName}</p>}
                </div>}
              </section>
            </section>
            {currentWishList.isOwner &&
            <section className={style.ownerActions}>
              <FormattedMessage id="wishList.add">{
                txt => <a className={style.add}
                          onClick={this.handleOpenProductModal}><i className={icons.iconPlusMedium}/>{txt}</a>
              }</FormattedMessage>
              <section className={style.groupActions}>
                <div className={style.delete}
                     onClick={this.handleDeleteModalOpen}><i className={icons.iconTrashcanMedium}/></div>
                <div className={style.edit}
                     onClick={this.handleEditModalOpen}><i className={icons.iconEditMedium}/></div>
              </section>
            </section>}
            {currentWishList.subtype !== 'PRIVATE' && !!currentWishList.user &&
            <section className={style.moreActions}>
              <FormattedMessage id="wishList.options.share">{
                text => <p onClick={this.handleShareListModalOpen}
                           className={style.share}><i className={icons.symbolShareDots}/>{text}</p>
              }</FormattedMessage>
              <button className={classNames(buttonStyle.btn, style.likeBtn,
                { [style.like]: currentWishList.liked })}
                      onClick={this.handleClickLikeBtn}>
                <i className={classNames(icons.iconThumbUpMedium, style.likeIcon)}/>
                <p className={style.likes}>{currentWishList.likes}</p>
              </button>
            </section>}
            {currentWishList.subtype === 'PRIVATE' && !!currentWishList.user &&
            <button className={classNames(buttonStyle.btn, style.likeBtn, style.private,
              { [style.like]: currentWishList.liked })}
                    onClick={this.handleClickLikeBtn}>
              <i className={classNames(icons.iconThumbUpMedium, style.likeIcon)}/>
              <p className={style.likes}>{currentWishList.likes}</p>
            </button>}
          </section>}
          {/*<section className={filterOptionsStyle.filterOptions}>
            <section className={filterOptionsStyle.header}>
              <FormattedMessage id="stores.filter.title">{
                text => <p className={filterOptionsStyle.title}><i className={icons.symbolTweak}/>{text}</p>
              }</FormattedMessage>
              <section className={filterOptionsStyle.sortOptions}>
                <FormattedMessage id="sort.title">{
                  txt => <label>{txt}</label>
                }</FormattedMessage>
                {sortNativeSelect}
              </section>
              <section className={filterOptionsStyle.filterDrawer}>
              <FilterDrawer drawerOpen={drawerOpen}
                            filterFields={(this.generateFilterFields(xxxx, this.state, false): any)}
                            color="lightBlue"
                            handleCloseDrawer={this.handleCloseDrawer}
                            handleOpenDrawer={this.handleOpenDrawer}
                            handleClearFilters={this.handleClearFilters}/>
            </section>
            </section>
          </section>*/}
          <section className={style.mainWrap}>
            <aside className={style.filterWrap}>
              {/*{filterContent}*/}
            </aside>
            <section className={style.rightWrap}>
              <AlertContainer showId="wish-list"/>
              {/*{!!tags.length && 
              <ul className={filterStyles.tags}>
                {tags}
              </ul>}*/}
              {noResult &&
              <FormattedMessage id="wishList.noResults">{
                txt => <p className={style.noResults}>{txt}</p>
              }</FormattedMessage>}
              {this.isLoading() ? <Loading className={style.loading}
                                           color="lightBlue"/> : productsResult}
            </section>
          </section>
        </section>
        {!!currentWishList &&
        <ProductModal localeState={localeState}
                      localValues={localValues}
                      handlePostProduct={this.handlePostProduct}
                      handleEditProduct={this.handleEditProduct}
                      handleCloseProductModal={this.handleCloseProductModal}
                      productModalOpen={productModalOpen || (isPostingProduct || isEditingProduct)}
                      product={currentWishList.items.find((product: WishListItem) => product.number === productId)}
                      isPostingProduct={isPostingProduct}
                      enableWishListTypes={enableWishListTypes}
                      isEditingProduct={isEditingProduct}
                      scrapUrl={scrapUrl}
                      isScrappingUrl={isScrappingUrl}
                      scrappedProduct={scrappedProduct}
                      scrapSuccess={scrapSuccess}
                      scrapUrlError={scrapUrlError}/>}
        <HomeForm goToRedirect={goToRedirect}
                  locale={localeState}
                  titleIntl="wishList.bottomBanner.title"
                  color='white'/>
        <Modal handleClose={this.handleCloseDeleteModal}
               open={deleteModalOpen || isDeletingProduct}
               closeOnEsc>
          {isDeletingProduct && <Loading type="circle"
                                         color="lightBlue"
                                         className={style.loading}
                                         number={3}/>}
          {!isDeletingProduct &&
          <section className={style.deleteModal}>
            <FormattedMessage id="wishList.delete.modal.title">{
              txt => <h2 className={style.title}>{txt}</h2>
            }</FormattedMessage>
            <FormattedMessage id="wishList.delete.modal.button.delete">{
              txt => <button className={classNames(buttonStyle.btn, buttonStyle.red, style.btn)}
                             onClick={this.handleDeleteProduct}>{txt}</button>
            }</FormattedMessage>
            <FormattedMessage id="wishList.delete.modal.button.close">{
              txt => <button className={classNames(buttonStyle.btn, buttonStyle.darkGrey, style.btn)}
                             onClick={this.handleCloseDeleteModal}>{txt}</button>
            }</FormattedMessage>
          </section>}
        </Modal>
        {!!currentWishList && !!currentWishList.user &&
        <ShareListModal openModal={shareListModalOpen}
                        handleClose={this.handleShareListModalClose}
                        localeState={localeState}
                        wishList={currentWishList}/>}
        <WishListModal mode="edit"
                       handleCloseModal={this.handleWishListModalClose}
                       openModal={editWishListModal}
                       createWishList={() => {
                       }}
                       editWishList={this.handleClickPutWishList}
                       handleChangeImage={this.handleChangeImage}
                       handleDeleteImage={this.handleDeleteImage}
                       handleChangeInputText={this.handleChangeInputText}
                       handleFocusInputText={this.handleFocusInputText}
                       handleChangeTypeOption={this.handleChangeTypeOption}
                       validateForm={this.validateForm}
                       name={name}
                       image={image}
                       wishListTypeOption={wishListTypeOption}/>
        <Modal open={deleteWishListModal}
               handleClose={this.handleDeleteModalClose}
               width={544}
               height={504}>
          <section className={style.deleteWishListModal}>
            <FormattedMessage id="myWishLists.deleteModal.title">{
              text => <h2>{text}</h2>
            }</FormattedMessage>
            <FormattedMessage id="myWishLists.deleteModal.button.delete">{
              text => <button className={classNames(style.delete, buttonStyle.btn, buttonStyle.red)}
                              onClick={this.handleClickDeleteWishList}>{text}</button>
            }</FormattedMessage>
            <FormattedMessage id="myWishLists.deleteModal.button.cancel">{
              text => <button className={classNames(style.cancelModal, buttonStyle.btn, buttonStyle.darkGrey)}
                              onClick={this.handleDeleteModalClose}>{text}</button>
            }</FormattedMessage>
          </section>
        </Modal>
      </Fragment>
    );
  }
}

WishList.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  user: PropTypes.object,
  authenticated: PropTypes.bool,
  localeState: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  handleOpenAuthModal: PropTypes.func,
  authModalVisible: PropTypes.bool,
  getUserWishList: PropTypes.func.isRequired,
  isFetchingWishList: PropTypes.bool,
  putWishListSuccess: PropTypes.bool,
  currentWishList: PropTypes.object,
  postProduct: PropTypes.func.isRequired,
  isPostingProduct: PropTypes.bool,
  editProduct: PropTypes.func.isRequired,
  isEditingProduct: PropTypes.bool,
  deleteProduct: PropTypes.func.isRequired,
  isDeletingProduct: PropTypes.bool,
  editLike: PropTypes.func.isRequired,
  isEditingLike: PropTypes.bool,
  error: PropTypes.object,
  goToRedirect: PropTypes.func.isRequired,
  resetWishListState: PropTypes.func.isRequired,
  putWishList: PropTypes.func.isRequired,
  putWishListError: PropTypes.object,
  isPuttingWishList: PropTypes.bool,
  deleteWishList: PropTypes.func.isRequired,
  deleteWishListError: PropTypes.object,
  isDeletingWishList: PropTypes.bool,
  deleteWishListSuccess: PropTypes.bool,
  scrapUrl: PropTypes.func.isRequired,
  isScrappingUrl: PropTypes.bool,
  scrappedProduct: PropTypes.object,
  scrapSuccess: PropTypes.bool,
  scrapUrlError: PropTypes.object,
};

WishList.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/wish-list/components/WishList.jsx